import { render } from "./SaveMykwsEmailServiceIcon.vue?vue&type=template&id=d4ded458"
import script from "./SaveMykwsEmailServiceIcon.vue?vue&type=script&lang=js"
export * from "./SaveMykwsEmailServiceIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__